import { useMutation, useQueryClient, type UseMutationResult } from "@tanstack/react-query";
import { useAuth } from "@/auth/AuthContext";
import { createApiClient } from "@/api/client";
import { queryKeys } from "@/api/queryClient";
import type { Agent } from "@/types";

// #335 (UC-5): den Puls eines Agenten freischalten oder abschalten
// (`PATCH /agents/:id/puls-enabled`, admin-only).
//
// ⚠ Abschalten LÖSCHT nichts: das Dokument bleibt gespeichert und ist nach dem
// Wiedereinschalten sofort wieder da; nur der Zugang darauf ist zu (das Tool wird im Brain
// nicht mehr registriert, die Master-Routen antworten 403, die App zeigt einen Hinweis).
// Deshalb invalidiert die Mutation ausser den Agenten AUCH die Meta-Sicht — sie trägt den
// Schalter-Zustand mit.
export function useUpdatePulsEnabled(agentId: string): UseMutationResult<Agent, Error, boolean> {
  const qc = useQueryClient();
  const { session, logout } = useAuth();
  return useMutation({
    mutationFn: (enabled) => {
      const client = createApiClient({
        getToken: () => session?.accessToken ?? null,
        onUnauthorized: logout,
      });
      return client.patch<Agent>(`/agents/${agentId}/puls-enabled`, { enabled });
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: queryKeys.resource("agents") });
      void qc.invalidateQueries({ queryKey: queryKeys.subResource("agents", agentId, "puls-meta") });
    },
  });
}
